/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "../../component/button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { connect } from "react-redux";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

const ResizablePaper = styled(Paper)(({ theme }) => ({
  resize: "both",
  overflow: "auto",
  minWidth: 640,
  minHeight: 200,
  maxWidth: "90vw",
  maxHeight: "90vh",
  width: "60vw",
}));

const ProviderConfirmation = (props) => {
  useEffect(() => {}, []);

  return (
    <div>
      <Dialog
        disableScrollLock
        aria-labelledby="form-dialog-title"
        open={props.open}
        maxWidth="lg"
        PaperComponent={FormDialogTitle}
        PaperProps={{
          component: ResizablePaper,
        }}
      >
        <DialogTitle id="form-dialog-title" style={{ cursor: "move" }}>
          {!props.action ? props.t("ADD_PROVIDER") : props.t("REMOVE_PROVIDER")}
        </DialogTitle>

        <DialogContent>
          <p>
            {!props.action ? (
              <>
                {props.t("ADD_PROVIDER_MESSAGE")} {props.item?.name}?
              </>
            ) : (
              <>
                {props.t("REMOVE_PROVIDER_MESSAGE")} {props.item?.name}?
              </>
            )}
          </p>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => props.close(true)} color="primary">
            {props.t("YES")}
          </Button>
          <Button onClick={() => props.close(false)} color="primary">
            {props.t("NO")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const FormDialogTitle = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds="parent"
      defaultClassName="customReactDraggableComponent"
      handle="#form-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <ResizablePaper ref={nodeRef} {...props} />
    </Draggable>
  );
};

// Redux connection
const mapStateToProps = (state) => ({
  tenantData: state.auth.tenantData,
});

export default connect(mapStateToProps)(ProviderConfirmation);
